import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "col-md-9 col-sm-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back to feed ")
const _hoisted_5 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-5 text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HacktivityWidget = _resolveComponent("HacktivityWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/club/feed",
          class: "btn btn-sm btn-light-primary font-weight-bolder py-2 px-5"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.feeds && _ctx.feeds[0])
              ? (_openBlock(), _createBlock(_component_HacktivityWidget, {
                  key: _ctx.feeds[0].id,
                  feed: _ctx.feeds[0],
                  show_comment: true,
                  currentUser: _ctx.user,
                  widgetClasses: 'mt-5'
                }, null, 8, ["feed", "currentUser"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
    ])
  ]))
}